<template>
    <div style="font-weight: 500; position: relative;">
        <div v-if="!isPopup" style="background: linear-gradient(71.64deg, rgba(240, 200, 153, 0.95) 0.25%, rgba(46, 153, 231, 0.95) 100%);">
            <div style="padding:0px 7px; margin-top: 26px; display: flex; justify-content: space-between; align-items: center;">
                <div style="display: flex; align-items: center; gap: 4px;">
                    <img style="width: 10px" :src="require('@/assets/img/back_btn_now.png')" alt="" />
                    <div @click="() => { $GlobalStore.closeLastModal() }" style="font-size: 14px;">뒤로가기</div>
                </div>
                <div v-if="this.$GlobalStore.isLogin()" @click="setIsShowPopMenu" style="padding-right: 12px; display: flex; flex-direction: column; padding-left: 20px; gap: 3px; position: relative;">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                </div>
            </div>
            <div style="text-align: center; margin-top: 16px;">
                <div style="font-weight: 700; font-size: 20px; margin-bottom: 8px;">{{ scheduleDetail.title }}</div>
                <div v-if="Object.keys(scheduleDetail).length !== 0" style="">{{ transDate(scheduleDetail.join_begin_date_time) }} {{ scheduleDetail.join_begin_date_time.split(' ')[1].substring(0, 5) }} ~ {{ scheduleDetail.join_end_date_time.split(' ')[1].substring(0, 5) }}</div>
            </div>
            <div v-if="Object.keys(scheduleDetail).length !== 0" style="margin-top: 16px; margin-bottom: 12px;">
                <template v-if="mode === CLASS_TYPE.PERSONAL_CLASS">
                    <div style="position: relative;">
                        <div class="personal_class_btn">₩ 60,000원으로 축구 배우기</div>
                    </div>
                </template>
                <template v-if="mode === CLASS_TYPE.NOW && scheduleDetail.creator.member_idx != myIdx">
                    <div v-if="scheduleDetail.is_me_joined" style="position: relative">
                        <div style="padding: 13px;" class="group_class_btn">나우 참여중 ...</div>
                        <div style="position: absolute; left: 50%; transform: translateX(-50%); top: 44px; z-index:10;">
                            <div style="position: relative">
                                <img style="width: 185px;" :src="require('@/assets/img/now_ballon.png')" alt="">
                                <div style="display: flex; align-items: center; position: absolute; top: 60%; gap: 6px; transform: translateY(-50%); padding: 0 12px;">
                                    <div style="font-size: 12px; font-weight: 500; white-space: nowrap;">나우 마감까지</div>
                                    <CalculateRemainTime :beginTime="scheduleDetail.join_begin_date_time"></CalculateRemainTime>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="!isPassDay && parseInt(scheduleDetail.max_cnt) !== parseInt(scheduleDetail.cur_cnt)" style="position: relative;">
                        <div class="group_class_btn" @click="showPayment">₩ {{ scheduleDetail.dues_group | comma }}원으로<br><span>나우에 참여하기</span></div>
                        <div style="position: absolute; left: 50%; transform: translateX(-50%); top: 55px; z-index: 50;">
                            <div style="position: relative">
                                <img style="width: 185px;" :src="require('@/assets/img/now_ballon.png')" alt="">
                                <div style="display: flex; align-items: center; position: absolute; top: 60%; gap: 6px; transform: translateY(-50%); padding: 0 12px;">
                                    <div style="font-size: 12px; font-weight: 500; white-space: nowrap;">나우 참여 가능</div>
                                    <CalculateRemainTime :beginTime="scheduleDetail.join_begin_date_time"></CalculateRemainTime>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="isPassDay || parseInt(scheduleDetail.max_cnt) === parseInt(scheduleDetail.cur_cnt)" class="groupe_class_btn_end">나우가 마감되었습니다</div>
                </template>
                <template v-else-if="scheduleDetail.creator.member_idx == myIdx && scheduleDetail.state == JOIN_STATE.CANCEL">
                    <div style="margin: 0 auto; width: 206px; height: 40px; line-height: 40px; border-radius: 22.5px; background: #210F0333; border: 1px solid #FFFFFF1A; text-align: center; color: #fff; font-size: 14px;">취소됨</div>
                </template>
                <template v-else-if="scheduleDetail.creator.member_idx == myIdx && scheduleDetail.state != JOIN_STATE.CANCEL">
                    <div style="position: relative">
                        <div @click="modifyNowSchedule" style="padding: 13px;" class="group_class_btn">나우 스케줄 설정</div>
                    </div>
                </template>
                <template v-if="mode === CLASS_TYPE.GROUP_SCHEDULE">
                    <div class="personal_class_btn_wrap">
                        <div class="group_class_btn small">₩ 30,000원으로<br>축구 단체수업 받기</div>
                        <div class="personal_schedule_btn">
                            <div style="line-height: 24px;">₩ 20,100원으로<br>그룹 스케줄 참여하기</div>
                            <!-- <div style="position: absolute;">
                                <div class="tooltip">
                                    <div>그룹이 모이면 9,900원 할인</div>
                                    <div class="close-btn"></div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div v-if="Object.keys(scheduleDetail).length !== 0" style="flex:1; display: flex; overflow:hidden;" @touchmove.stop="() => { }">
            <InfinityScroll :refresh-action="refresh" style="height: 100%;">
                <div style="overflow-x: hidden;">
                    <div style="padding: 0 12px; margin-top: 16px;">
                        <div style="font-weight: 700; font-size: 12px; margin-bottom: 10px;">담당 코치</div>
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <div @click.stop="$Util.showProfile(scheduleDetail.creator_idx, scheduleDetail.creator_type, '', scheduleDetail.creator.is_coach)">
                                <ProfileImage style="width: 60px;" :imagePath="scheduleDetail.creator.image_path"></ProfileImage>
                            </div>
                            <div style="display: flex; align-items: center; gap: 3px;">
                                <div style="font-weight: 700;">{{ scheduleDetail.creator.nic_name }}</div>
                                <div style="font-weight: 700; font-size: 14px; color: #606060;">{{ scheduleDetail.creator.position }}</div>
                                <div>
                                    <img style="width: 16px;" :src="require('@/assets/img/coach_star.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 1px; background-color: #ebebeb; width: calc(100% - 24px); margin: 16px auto;"></div>
                    <div style="padding: 0 12px;">
                        <div style="font-weight: 700; font-size: 12px; margin-bottom: 10px;">나우 소개</div>
                        <div style="font-size: 14px; line-height: 24px;">{{ scheduleDetail.contents }}</div>
                    </div>
                    <div class="hide_scroll" style="display: flex; overflow-x: scroll; margin-top: 10px; border-top: 1px solid #ededed; border-bottom: 1px solid #ededed; padding: 12px 20px">
                        <!-- <div class="cont_wrap_box">
                            <div class="title">장소</div>
                            <div @click="showInMap" style="color: var(--color-main);" class="sub_title">지도에서 보기</div>
                            <div class="sub_title2">{{ scheduleDetail.place_name }}</div>
                        </div> -->
                        <div style="" class="cont_wrap_box">
                            <div class="title">참여 인원</div>
                            <div class="sub_title">최대</div>
                            <div class="sub_title2">{{ scheduleDetail.max_cnt }}명</div>
                        </div>
                        <div style="padding-left: 16px" class="cont_wrap_box">
                            <div class="title">참여 비용</div>
                            <div class="sub_title">₩</div>
                            <div class="sub_title2">{{ scheduleDetail.dues_group | comma }}원</div>
                        </div>
                        <div style="padding-left: 16px" class="cont_wrap_box">
                            <div class="title">진행 시간</div>
                            <div class="sub_title">1회</div>
                            <div class="sub_title2">{{ $Util.getTimeGapStr(scheduleDetail.join_begin_date_time, scheduleDetail.join_end_date_time) }}</div>
                        </div>
                        <div style="padding-left: 16px" class="cont_wrap_box">
                            <div class="title">연령대</div>
                            <div class="sub_title">추천</div>
                            <div class="sub_title2">{{ scheduleDetail.recommend_age }}</div>
                        </div>
                        <div style="padding-left: 16px; border: none" class="cont_wrap_box">
                            <div class="title">성별</div>
                            <div class="sub_title">추천</div>
                            <div class="sub_title2">{{ scheduleDetail.sex }}</div>
                        </div>
                    </div>
                    <div style="margin-top: 16px; margin-bottom: 16px; padding: 0 12px;">
                        <div style="font-weight: 700; font-size: 12px;">나우 멤버 {{ parseInt(scheduleDetail.cur_cnt) }}</div>
                        <div @touchmove.stop="() => { }" class="hide_scroll" style="display: flex; overflow-x: scroll; gap: 25px; margin: 0 -12px; padding: 0 12px; margin-top: 10px">
                            <!-- <div style="display: flex; flex-direction: column; align-items: center;">
                                <ProfileImage style="width: 40px;" :imagePath="scheduleDetail.creator.image_path"></ProfileImage>
                                <div style="white-space: nowrap; display: flex; align-items: center; gap: 4px;">
                                    <div style="line-height: 24px; font-weight: 700; font-size: 12px;">{{ scheduleDetail.creator.nic_name }}</div>
                                    <div style="font-weight: 700; color: #808080; font-size: 10px;">{{ scheduleDetail.creator.position }}</div>
                                </div>
                            </div> -->
                            <div style="display: flex; flex-direction: column; align-items: center;" v-for="each, i in scheduleMembers" :key="i">
                                <div @click="$Util.showProfile(each.member_idx, each.member_type, '', each.is_coach)">
                                    <ProfileImage style="width: 40px;" :imagePath="each.image_path"></ProfileImage>
                                </div>
                                <div style="white-space: nowrap; display: flex; align-items: center; gap: 4px;">
                                    <div style="line-height: 24px; font-weight: 700; font-size: 12px;">{{ each.nic_name }}</div>
                                    <div style="font-weight: 700; color: #808080; font-size: 10px;">{{ $Util.position_display_str(each.member_type, each.position, each.is_coach) }}</div>
                                </div>
                            </div>
                            <div style="width: 40px; height: 40px; border-radius: 50%; color: #606060; font-size: 24px; border: 1px solid #d9d9d9; background-color: #f5f5f5; flex-shrink: 0; display: flex; justify-content: center; align-items: center;" v-for="index in new Array(parseInt(scheduleDetail.max_cnt) - (scheduleDetail.cur_cnt))" :key="index" @click="showInvitationMembers">
                                +
                            </div>
                        </div>
                    </div>
                    <div style="height: 8px; width: calc(100% + 24px); margin-left: -12px; background-color: #f5f5f5;"></div>
                    <div style="margin-top: 20px; margin-bottom: 20px;">
                        <div style="margin-left: 12px; margin-bottom: 12px;">
                            <div style="font-size: 12px;font-weight: 700;line-height: 24px;">나우가 진행되는 구장</div>
                            <div style="font-size: 14px;font-weight: 700;line-height: 24px; margin-top: 4px;">{{ scheduleDetail.place_name }}</div>
                            <div style="font-size: 12px; font-weight: 500; color: #606060;">{{ scheduleDetail.address }}</div>
                        </div>
                        <div style="display: flex; gap: 12px; overflow-x: scroll; padding: 0 12px; align-items: center;" class="hide_scroll">
                            <div v-for="each, i in groundImages" style="position: relative" :key="i" @click="showImageViewer(i)">
                                <img style="width: 200px; height: 230px; object-fit: cover; border-radius: 12px" :src="$resourcePath + each.src" alt="">
                            </div>
                        </div>
                    </div>
                    <div style="height: 8px; width: calc(100% + 24px); margin-left: -12px; background-color: #f5f5f5;"></div>
                    <div style="margin-top: 16px; padding: 0 12px">
                        <div style="font-weight: 700; font-size: 12px; margin-bottom: 10px;">댓글 {{ replyList.length }}</div>
                        <div v-if="replyList.length !== 0">
                            <div v-for="each, i in replyList" :key="i + 'reply'" style="display: flex; gap: 6px; margin-bottom: 16px; position: relative;">
                                <div style="position: absolute; line-height: 20px; font-size: 12px; color: #606060; font-weight: 500; right: 0;">{{ each.insert_date | agoDateStr }}</div>
                                <div @click="$Util.showProfile(each.writer_idx, each.writer_type, '', each.writer_is_coach)">
                                    <ProfileImage style="width: 40px; height: 40px;" :imagePath="each.image_path"></ProfileImage>
                                </div>
                                <div>
                                    <div style="white-space: nowrap; display: flex; align-items: center; gap: 4px;">
                                        <div style="line-height: 24px; font-weight: 700; font-size: 12px;">{{ each.nic_name }}</div>
                                        <div style="font-weight: 700; color: #808080; font-size: 10px;">{{ $Util.position_display_str(each.writer_type, each.position, each.writer_is_coach) }}</div>
                                    </div>
                                    <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.contents }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <RecommendReplyList :clickContents="setRecommendReply" :directInput="focusReplyInput" :recommendReplyList="recommendReplyList" :subTitle="'질문 및 후기 등을 댓글로 남길 수 있습니다.'" :recommendMent="'추천 댓글'"></RecommendReplyList>
                        </div>
                    </div>
                    <!-- <div style="height: 8px; width: calc(100% + 24px); margin-left: -12px; background-color: #f5f5f5;"></div>
                    <div style="margin-top: 16px; padding: 0 12px;">
                        <div style="font-weight: 700; font-size: 12px; margin-bottom: 10px;">수업이 진행되는 구장</div>
                        <div style="margin-top: 8px;">
                            <div style="font-weight: 700; font-size: 14px; margin-bottom: 4px;">강서개화축구장</div>
                            <div style="font-size: 12px; color: #606060;">인천광역시 계양구 하야동 23-9</div>
                        </div>
                        <div class="hide_scroll" style="display: flex; margin: 0 -12px; padding: 0 12px; margin-top: 12px; gap: 12px; overflow-x: scroll; margin-bottom: 20px;">
                            <div style="flex-basis: 200px; height: 230px; flex-shrink: 0; background-color: #606060; border-radius: 12px;">
                                지도
                            </div>
                            <div style="flex-basis: 200px; height: 230px; flex-shrink: 0; background-color: #606060; border-radius: 12px;">
                                구장사진
                            </div>
                        </div>
                    </div>
                    <div style="height: 8px; background-color: #ebebeb; margin-bottom: 16px"></div>
                    <div style="padding: 0 12px;">
                        <div style="font-weight: 700; font-size: 12px; margin-bottom: 12px;">스케줄 테이블</div>
                        <CalendarScheduleTable :is-toggle-hidden="true" :isFirstShowMonth="true"></CalendarScheduleTable>
                        <div style="margin-top: 12px;">
                            <div style="display: flex; align-items: center; gap: 4px;">
                                <div style="width: 4px; height: 4px; background-color: black; border-radius: 50%;"></div>
                                <div style="font-size: 12px;">테이블에서 원하는 날짜와 시간을 선택할 수 있습니다.</div>
                            </div>
                            <div style="display: flex; align-items: center; gap: 4px; margin-top: 6px;">
                                <div style="width: 4px; height: 4px; background-color: black; border-radius: 50%;"></div>
                                <div style="font-size: 12px;">스케줄 예약하기 버튼을 눌러 선택한 스케줄을 예약할 수 있습니다.</div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 8px; background-color: #ebebeb; margin: 16px 0;"></div>
                    <template v-if="mode !== CLASS_TYPE.PERSONAL_CLASS">
                        <div style="padding: 0 12px;">
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                <div style="font-weight: 700; font-size: 12px;">그룹 스케줄</div>
                                <div>
                                    <img style="width: 20px;" :src="require('@/assets/img/notice_class.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </template> -->
                </div>
            </InfinityScroll>
        </div>
        <div v-if="Object.keys(scheduleDetail).length !== 0 && this.$GlobalStore.isLogin()" style="background-color: #fff; padding: 0 12px; padding-bottom: 20px; border-top:1px solid #F5F5F5;">
            <div style="display:flex; width:100%; padding-top:8px; align-items: flex-end; background-color: white; ">
                <div style="flex:1; position: relative; display: flex; gap: 8px;">
                    <ProfileImage style="width: 40px; height: 40px" :imagePath="myImage"></ProfileImage>
                    <textarea ref="reply" v-model="replyContents" rows="1" style="flex:1; width: 100%; background-color: #efefef; resize:none; outline: none; border:0px; padding:10px 15px; border-radius:20px; font-size:14px; line-height:20px; overflow:hidden; max-height: 350px; padding-right: 40px; overflow-y: scroll;" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"'></textarea>
                    <div @click="saveReply">
                        <div v-if="replyContents.length === 0" style="width: 32px; height: 32px; display: flex; justify-content: center; align-items: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%); background-color: #D9D9D9; border-radius: 50%;">
                            <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                        </div>
                        <div v-else style="width: 32px; background-color: #210f03; display: flex; align-items: center; justify-content: center; height: 32px; border-radius: 50%; display: flex; justify-content: center; position: absolute; right: 12px; top: 50%; transform: translateY(-50%);">
                            <img :src="require('@/assets/img/chat_send_white.png')" style="width:12px; height:16px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="(device !== 'ios' && device !== 'android') && !this.$GlobalStore.isLogin()" style="padding-bottom: 20px; position: relative; backdrop-filter: blur(3px) contrast(1.5); -webkit-backdrop-filter: blur(3px);">
            <div style="margin-top: 12px; text-align: center; line-height: 24px; font-size: 14px; font-weight: 500;">사커하우에 로그인하여<br>나우에 참여할 수 있습니다.</div>
            <div style="display: flex; margin-top: 12px; gap: 12px; padding: 0 12px;">
                <div @click="showInApp" style="padding: 19px 0; background-color: #ededed; text-align: center; flex: 1; border-radius: 12px; font-size: 14px;">앱에서 보기</div>
                <div v-if="isIOSWeb" @click="downloadApp" style="padding: 19px 0; background-color: #ededed; text-align: center; flex: 1; border-radius: 12px; font-size: 14px;">앱 다운로드</div>
                <div @click="showLogin" style="padding: 19px 0; background-color: #210f03; color: #fff; text-align: center; flex: 1; border-radius: 12px; font-size: 14px;">회원가입 하기</div>
            </div>
        </div>
        <BottomPopupMenu :is-open="isShowPopMenu" :menu-options="menuOptions"></BottomPopupMenu>
        <EditModalFrame v-if="!(isCoach === '1' || isTempCoach === '1')" :isOpen="isShowNowFeedBack" :noTitle="true" :closeModal="closeNowFeedBack">
            <div style="text-align: center; position: relative; padding: 8px 0; padding-top: 48px">
                <div>
                    <img style="width: 134px;" :src="require('@/assets/img/now_logo.png')" alt="">
                </div>
                <div style="font-weight: 700; font-size: 20px; line-height: 24px; margin-top: 24px">코치님의 피드백을 받으며<br>매치까지 한번에</div>
                <div style="margin-top: 16px; font-weight: 500; font-size: 14px; line-height: 24px; color: #606060;">
                    나우는 저렴한 금액으로 코치님과 축구를 같이하는 방법입니다.
                    비전문가의 실력 검증이 아닌, 진짜 축구 전문가의 전문적인
                    실전 노하우와 훈련 피드백을 만나볼 수 있습니다.
                    코치님에게 직접 피드백을 받으면서 매치까지
                    같이 뛰어볼 수 있는 사커나우에 참여해보세요.
                </div>
            </div>
            <div @click="closeNowFeedBack" style="padding: 12px; margin-top: 16px; background-color: #f5f5f5; border-radius: 12px; text-align: center; font-weight: 700; font-size: 14px; line-height: 24px;">확인</div>
        </EditModalFrame>
        <EditModalFrame :isOpen="isShowRefund" :title="'참여 취소 및 환불 규정'" :closeModal="closeRefund">
            <div class="hide_scroll" style="position: relative; padding: 20px 0; max-height: 500px; overflow-y: scroll;">
                <div style="margin-bottom: 30px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">1. 나우 취소 규정</div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">나우 스케줄 예약은 수업 시작일 자정까지 무료로 취소할 수있습니다.</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">나우 스케줄이 진행되는 날에는 예약 취소 시 경과 시간에 따라 환불 비율이 달라집니다.</div>
                    </div>
                </div>
                <div style="margin-bottom: 30px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">2. 환불이 어려운 경우</div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">스케줄을 실수로 잘못 예약한 경우</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">단순 변심으로 취소 혹은 변경을 요청하는 경우</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">코치 혹은 나우 스케줄에 불만족할 경우</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">정당성이 인정되지 않아 환불이 어려운 경우</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">예약자 본인이 아닌 다른 사람이 나우 스케줄에 참여할 경우</div>
                    </div>
                </div>
                <div style="">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">3. 정당성으로 인해 환불이 가능한 경우</div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">코치의 요청으로 나우 스케줄이 취소될 경우</div>
                    </div>
                </div>
                <div style="line-height: 20px; font-size: 12px; color: #606060; margin-top: 20px;">판단근거 : 코치가 임의로 수업을 취소하는 경우는 코치의 개인적인 사유로 인한 스케줄 진행 불가 혹은 배경적 (기후, 사고, 시설 문제 등)으로 스케줄 취소가 불가피한 상황이라고 판단하여 시간 경과에 관계없이 100% 환불됩니다.</div>
                <div style="margin-top: 20px">
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">나우 참여 인원이 부족해 취소되었을 경우</div>
                    </div>
                </div>
                <div style="margin-top: 20px">
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">코치의 태도가 불성실하거나 적긍성이 없어보이는 경우 혹은 코치로부터 인격적인 피해를 받았을 경우</div>
                    </div>
                </div>
                <div style="line-height: 20px; font-size: 12px; color: #606060; margin-top: 20px;">판단근거 : 폭력 발생, 심한 욕설, 협박, 과한 스킨십(터치), 정치/선동적인 언행, 시대착오적/차별적인 언행, 난폭한 코칭, 부상 유도 및 유발 등 사례에 따라 피해의 경중을 판단하여 환불 정당성을 인정합니다.</div>
                <div style="margin-top: 20px">
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">위험 수준의 감염병이 발병하여 격리 조치가 권고될 경우</div>
                    </div>
                </div>
                <div style="">
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">예상치 못한 기상악화(폭설, 폭우 등)으로 인해 취소될 경우</div>
                    </div>
                </div>
                <div style="margin-top: 30px;">
                    <div style="font-weight: 700; font-size: 14px; line-height: 24px;">4. 환불 비율</div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">스케줄 시작 시간 48시간 전: 전액 환불</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">스케줄 시작 시간 24시간 전: 예약 금액의 80% 환불</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">스케줄 시작 시간 12시간 전: 예약 금액의 50% 환불</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">스케줄 시작 시간 6시간 전: 예약 금액의 10% 환불</div>
                    </div>
                    <div style="display: flex; gap: 8px;">
                        <div style="width: 4px; height: 4px; flex-shrink: 0; border-radius: 50%; background-color: #210f03; margin-top: 10px;"></div>
                        <div style="line-height: 24px; font-size: 14px; font-weight: 500">스케줄 시작 이후: (경과 시간에 상관 없이)환불 불가</div>
                    </div>
                </div>
            </div>
            <div @click="closeRefund" style="padding: 12px; background-color: #f5f5f5; border-radius: 12px; margin-top: 12px; text-align: center; font-weight: 700; font-size: 14px; line-height: 24px;">확인</div>
        </EditModalFrame>
        <div style="position: relative; z-index: 100;">
            <ShareSchedule :schedule-idx="scheduleDetail.idx" :is-open="isShowShareSchedule" :close-complete-action="() => { isShowShareSchedule = false }" />
        </div>
        <div v-if="isShowWebAppLinkPop" style="position:fixed; background-color: rgba(15, 6, 0, 0.4); width:100%; height:100%; left:0px; top:0px; display:grid; place-items: center; z-index:100">
            <div style="">
                <div style="font-size:16px; font-weight:bold; color:white; text-align:center;">앱에 접속하여 포지션 찾기 및</div>
                <div style="font-size:16px; font-weight:bold; color:white; text-align:center; margin-top:5px;">팀트레이닝 서비스를 더욱 자세히 만나보세요!</div>
                <div style="margin-top:20px;text-align:center;">
                    <img :src="require('@/assets/img/now_detail_pop.png')" style="width:300px;">
                </div>
                <div style="margin-top:15px; width:300px;">
                    <div style="color:#210F03; font-size:14px; font-weight:500; background-color:white; height:44px;display:grid;place-items: center; border-radius:22px;" @click="showInApp">앱으로 접속하기</div>
                    <div v-if="isIOSWeb" style="color:#210F03; font-size:14px; font-weight:500; margin-top:10px; background-color:white; height:44px; display:grid;place-items: center; border-radius:22px;" @click="downloadApp">앱 다운로드</div>
                </div>
                <div>
                    <div style="font-size:14px; font-weight:500; text-decoration: underline; margin-top:15px;text-align:center; color:white;" @click="closeWebAppLinkPop">일단 웹에서 보겠습니다.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import RecommendReplyList from '@/components/common/RecommendReplyList'
import EditModalFrame from '@/components/modal/my/EditModalFrame';
// import CalendarScheduleTable from '@/components/common/CalendarScheduleTable'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import { CLASS_TYPE, JOIN_STATE } from '@/Constants'
import ResponseCode from '../../../ResponseCode'
import ShareSchedule from "../../common/ShareSchedule";
import moment from 'moment'
import CalculateRemainTime from '@/components/common/CalculateRemainTime'
import InfinityScroll from '@/components/common/InfinityScroll'
import { PUSH_ACTION } from "../../../Constants";

export default {
    name: 'ClassScheduleDetail',
    components: { ShareSchedule, ProfileImage, InfinityScroll, EditModalFrame, BottomPopupMenu, RecommendReplyList, CalculateRemainTime },
    props: {
        mode: {
            type: String,
            default: CLASS_TYPE.NOW,
        },
        isPopup: {
            type: Boolean,
            default: false,
        },
        scheduleIdx: {
            type: [Number, String],
            default: -1
        },
        isEnd: {
            type: Boolean,
            default: false
        },
        noPopup: {
            type: Boolean,
            default: false
        },
        completeAction: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            CLASS_TYPE: CLASS_TYPE,
            JOIN_STATE: JOIN_STATE,
            isShowPopMenu: false,
            menuOptions: {},
            scheduleDetail: {},
            scheduleMembers: [],
            replyList: [],
            isShowReplyInput: false,
            replyContents: '',
            recommendReplyList: [
                { contents: '어떤 식으로 진행되나요?' },
                { contents: '필요한 준비물이 있나요?' },
                { contents: '초보인데도 참여할 수 있나요?' },
                { contents: '경기도 같이 진행되나요?' },
                { contents: '정말 많은걸 배워갑니다' },
            ],
            isShowNowFeedBack: false,
            isShowRefund: false,
            isShowShareSchedule: false,
            isPassDay: false,
            isRepeat: false,
            repeatScheduleInfo: {},
            isLogin: true,
            device: null,
            groundImages: [],
            isShowWebAppLinkPop : false
        }
    },
    computed: {
        transTextClassType() {
            if (this.mode === CLASS_TYPE.PERSONAL_CLASS) {
                return '개인수업'
            } else {
                return '단체수업'
            }
        },
        myImage() {
            return this.$GlobalStore.loginInfo().image_path
        },
        myIdx() {
            if (this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().idx) {
                return this.$GlobalStore.loginInfo().idx;
            } else {
                return null;
            }
        },
        isMeCreator() {
            return this.$GlobalStore.loginInfo().idx == this.scheduleDetail.creator_idx;
        },
        isCoach() {
            return this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_coach
        },
        isTempCoach() {
            return this.$GlobalStore.loginInfo() && this.$GlobalStore.loginInfo().is_temp_coach
        },
        isIOSWeb() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        }
    },
    methods: {
        closeWebAppLinkPop(){
            sessionStorage.setItem('IS_SHOW_NOW_DETAIL_APPLINK_POP', true);
            this.isShowWebAppLinkPop = false;
        },
        showImageViewer(index) {
            if (this.groundImages.length === 0) return
            const image_paths = this.groundImages.map((each) => each.src);
            this.$GlobalStore.addModal('ImageViewer', { imagePaths: image_paths, initIndex: index });
        },
        showInApp() {
            const userAgent = navigator.userAgent;
            const action = PUSH_ACTION.WEB_NOWPAGE;
            const param0 = this.scheduleIdx;

            if (userAgent.match(/android/i)) {
                location.href = `intent://action?action=${action}&param0=${param0}#Intent;scheme=obyungearuser;package=com.ubiplus.custom.obyungear_user;end`
            } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
                location.href = `obyungearuser://?action=${action}&param0=${param0}`;
            }
        },
        downloadApp() {
            location.href = 'itms-apps://itunes.apple.com/app/id6443870201';
        },
        showLogin() {
            // this.$GlobalStore.addModal('Login', { transitionName: 'bottom' });
            this.$GlobalStore.addModal('MemberTypeSelect', {
                isExistLoginBtn: true, isShowCloseBtn: true, completeAction: (register_type) => {
                    this.$GlobalStore.addModal('RegistTypeSelect', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
                    // this.$GlobalStore.addModal('MemberRegist', { isModalBackTransparent: true, transitionName: 'bottom', register_type: register_type });
                }
            })
        },
        refresh() {
            this.replyList = []
            this.scheduleMembers = []
            this.getReplyList()
            this.getScheduleDetail()
        },
        showInMap() {
            this.$GlobalStore.closeModalAll();
            this.$GlobalRouter.push('/view/mercenary_map?time=' + new Date().getTime() + '&schedule_idx=' + this.scheduleDetail.idx + '&type=place');
        },
        showInvitationMembers() {
            if (this.scheduleDetail.state == JOIN_STATE.CANCEL) {
                return
            }
            this.$GlobalStore.addModal('ModalFindMercenaryPopup', {
                transitionName: '', isModalBackTransparent: true, region_result: { region_code: this.scheduleDetail.region_code }, completeAction: (data) => {
                    const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:500; line-height: 24px; font-size:14px;">[${data.nic_name}]를<br>초대하시겠습니까?</div>`;
                    this.$GlobalStore.showConfirm(html, async () => {
                        const parameters = {};
                        parameters.member_idx = data.member_idx;
                        parameters.member_type = data.member_type;
                        parameters.join_schedule_idx = this.scheduleDetail.idx;
                        const res = await this.$Axios.post('/api/join/schedule/lesson/invite', parameters);
                        if (res.data.code === ResponseCode.SUCCESS) {
                            await this.$Axios.showChattingBySoccerJoinIdx(res.data.chat_idx);
                        } else if (res.data.code === ResponseCode.FAIL) {
                            this.$GlobalStore.showAlert(res.data.msg);
                        } else if (res.data.code === ResponseCode.SCHEDULE_INVITATION_REJECT) {
                            this.$Util.showRejectSchedulePopup()
                        }

                    }, '초대하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION5)
                }
            });
        },
        modifyNowSchedule() {
            this.$GlobalStore.addModal('MakeClassScheduleFeedPopup', { transitionName: '', isModalBackTransparent: true, scheduleIdx: this.scheduleDetail.idx, completeAction: this.getScheduleDetail })
        },
        closeRefund() {
            this.isShowRefund = false
        },
        closeNowFeedBack() {
            this.isShowNowFeedBack = false
        },
        setRecommendReply(reply) {
            this.replyContents = reply
        },
        focusReplyInput() {
            this.$refs.reply.focus()
        },
        async saveReply() {
            if (this.replyContents.length === 0) {
                this.$GlobalStore.showAlert('내용을 입력해주세요.')
                return
            }
            const formData = new FormData()
            formData.append('parentIdx', this.scheduleIdx)
            formData.append('contents', this.replyContents)
            formData.append('type', 'schedule')
            formData.append('mode', 'insert')

            const res = await this.$Axios.post('/api/soccerhow/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.replyContents = ''
                this.$refs.reply.style.height = ''
                this.getReplyList()
            }
        },
        setIsShowReplyInput() {
            // if (!this.scheduleDetail.is_me_joined) {
            //     const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">스케줄 멤버만 댓글로 소통할 수 있습니다.</div>`;
            //     this.$GlobalStore.showConfirm(html, () => {
            //
            //     }, '확인', null, this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
            //     return
            // }
            this.isShowReplyInput = !this.isShowReplyInput
        },
        confirmCaccel() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">나우 취소하기</div><div style="padding:0px 12px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br>나우는 초대를 통해서도 인원을 모을 수 있기 때문에<br>가급적 취소하지 않는 것을 권장합니다.<br>진행중인 나우를 취소할까요?</div>`; this.$GlobalStore.showConfirm(html, () => {
                this.cancelNow()
            }, '나우 취소하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
        },
        async cancelNow() {
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleDetail.idx)

            const res = await this.$Axios.post('/api/join/schedule/cancel', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.getScheduleDetail()
                this.completeAction(true)
            }
        },
        setIsShowPopMenu() {
            this.isShowPopMenu = true;
            const labelAndAction = [];


            if (this.isMeCreator && this.scheduleDetail.state != JOIN_STATE.CANCEL) {
                labelAndAction.push(
                    {
                        label: '나우 취소하기', action: () => {
                            this.confirmCaccel()
                            this.isShowPopMenu = false
                        },
                    },
                    {
                        label: '나우 수정하기', action: () => {
                            this.modifyNowSchedule()
                            this.isShowPopMenu = false
                        },
                    },
                )
            }

            if (!this.isMeCreator) {
                if (this.scheduleDetail.is_me_joined) {
                    labelAndAction.push(
                        {
                            label: '나우 예약 취소하기', action: () => {
                                this.confirmExit()
                                this.isShowPopMenu = false
                            },
                        }
                    )
                } else if (!this.isPassDay) {
                    labelAndAction.push(
                        {
                            label: '나우 참여하기', action: () => {
                                this.showPayment()
                                this.isShowPopMenu = false
                            },
                        },
                    )
                }
                labelAndAction.push({
                    label: '나우 스케줄 공유하기', action: () => {
                        this.isShowShareSchedule = true;
                        this.isShowPopMenu = false
                    },
                });
            }

            if (this.isRepeat && this.isMeCreator && this.scheduleDetail.state != JOIN_STATE.CANCEL && this.repeatScheduleInfo.is_stop == 0) {
                labelAndAction.push({
                    label: '나우 반복 중단', action: () => {
                        this.confirmRepeatStop()
                        this.isShowPopMenu = false
                    }
                })
            }

            labelAndAction.push({
                label: '참여 취소 및 환불 규정 보기', action: () => {
                    this.isShowPopMenu = false
                    this.isShowRefund = true
                }
            });

            this.menuOptions = {
                labelAndAction: labelAndAction,
                isExistCancelBtn: true,
                closeAction: () => {
                    this.isShowPopMenu = false
                }
            }

        },
        confirmRepeatStop() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">나우 반복 중단하기</div><div style="padding:0px 15px; line-height: 20px; font-size:14px; padding-bottom:15px; white-space: nowrap;"><br>반복을 멈출 경우 앞으로 나우가 자동으로 생성되지 않으며<br>이번주만 진행되는 나우로 변경됩니다.<br>나우 반복을 멈출까요?</div>`; this.$GlobalStore.showConfirm(html, () => {
                this.repeatStop()
            }, '나우 반복 멈추기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
        },
        async repeatStop() {
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            formData.append('is_stop', 1)
            formData.append('repeat_schedule_idx', this.repeatScheduleInfo.idx)
            const res = await this.$Axios.post('/api/join/repeat/schedule/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.getScheduleDetail()
            } else {
                console.log(res.data.msg)
                this.$GlobalStore.hideProgress()
            }
        },
        confirmExit() {
            const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">나우 취소하기</div><div style="padding:0px 15px; line-height: 20px; font-size:14px; padding-bottom:15px;"><br>예약은 수업 시작일 자정까지 무료로 취소할 수<br>있으며, 이후부터는 시간에 따라 환불 비율이 달라집니다.<br>자세한 내용은 규정을 통해 확인해주시기 바랍니다.<br>나우 예약을 취소할까요?</div>`; this.$GlobalStore.showConfirm(html, () => {
                this.exitNow()
            }, '나우 예약 취소하기', '취소', this.$GlobalStore.CONFIRM_TYPE.VERSION5, false, () => { })
        },
        showPayment() {
            this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '수업 비용', amt: this.scheduleDetail.dues_group });
        },
        async payAction(pay_method, pay_mode, card_idx) {
            const parameters = {};
            parameters.pay_mode = pay_mode;
            // amt 실제결제금액
            parameters.amt = parseInt(this.scheduleDetail.dues_group.replaceAll(',', ''))
            parameters.goods_name = '나우 1회';
            parameters.card_idx = card_idx;
            // 해당되는 idx 
            parameters.join_schedule_idx = this.scheduleIdx;

            await this.$Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                return await this.$Axios.post('/api/join/schedule/apply', converted_parameters);
            }, async (converted_parameters) => {
                const res = await this.$Axios.post('/api/join/schedule/apply', converted_parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.closeLastModal();
                    this.getScheduleDetail()
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            })
        },
        async exitNow() {
            const formData = new FormData()
            formData.append('join_schedule_idx', this.scheduleIdx)

            const res = await this.$Axios.post('/api/join/schedule/exit', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.getScheduleDetail()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        closeAction() {
            this.isOpen = false;
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        async getReplyList() {
            const parameters = {}
            parameters.parentIdx = this.scheduleIdx
            parameters.replyDeep = 1
            parameters.parent_type = 'schedule'
            parameters.child_type = 'schedule'

            const res = await this.$Axios.get('/api/soccerhow/replies', { params: parameters })
            this.replyList = res.data.replies
        },
        async getScheduleDetail() {
            const parameters = {}
            parameters.join_schedule_idx = this.scheduleIdx;
            parameters.is_visit = true;
            this.groundImages = []

            const res = await this.$Axios.get('/api/join/schedule/detail', { params: parameters });
            if (!res.data.join_schedules) {
                this.$GlobalStore.showAlert('삭제된 수업입니다.');
                this.$GlobalStore.closeLastModal();
                return
            }

            const scheduleDetail = res.data.join_schedules
            const scheduleMembers = res.data.join_schedule_members
            const groundImages = res.data.join_schedule_images ?? []

            for (let i = 0; i < 5; i++) {
                if (groundImages['image_path' + i]) {
                    this.groundImages.push({ src: groundImages['image_path' + i] })
                }
            }

            const filteredMembers = scheduleMembers.filter(item =>
                parseInt(item.member_idx) !== scheduleDetail.creator.member_idx
            );

            this.scheduleDetail = scheduleDetail
            this.repeatScheduleInfo = res.data.repeat_schedule
            this.scheduleDetail.cur_cnt = parseInt(this.scheduleDetail.cur_cnt) - 1
            this.scheduleDetail.max_cnt = parseInt(this.scheduleDetail.max_cnt) - 1
            this.isPassDay = this.checkIsPassDay(this.scheduleDetail.join_begin_date_time)
            this.isRepeat = res.data.repeat_schedule ? true : false
            this.scheduleMembers = filteredMembers
        },
        checkIsPassDay(joinDate) {
            const currentDate = moment()
            const givenDate = moment(joinDate, 'YYYY-MM-DD HH:mm:ss.SSS')

            if (currentDate.isBefore(givenDate)) {
                return false
            } else if (currentDate.isAfter(givenDate)) {
                return true
            } else {
                return true
            }
        },
        transDate(date) {
            if (date.split(' ')[0] === this.today) {
                return ''
            } else {
                const transDate = this.$Util.getMMDDDayHangulStr(date).split(' ')
                transDate.splice(0, 1)

                return transDate.join(' ')
            }

        },
    },
    created() {
        this.isLogin = this.$GlobalStore.isLogin()
        const device = this.$cookies.get('device')
        this.device = device

        this.getScheduleDetail()
        this.getReplyList()
        if (!this.noPopup) {
            setTimeout(() => {
                this.isShowNowFeedBack = true
            }, 1000);
        }

        const userAgent = navigator.userAgent;
        if ( (userAgent.match(/iPhone|iPad|iPod/i) || userAgent.match(/android/i)) && (device !== 'android' && device !== 'ios') && !this.$hasOwnProperty(sessionStorage, 'IS_SHOW_NOW_DETAIL_APPLINK_POP')) {
            this.isShowWebAppLinkPop = true;
        }

    }
}
</script>

<style scoped>
.circle {
    width: 5px;
    height: 5px;
    background-color: #210f03;
    border-radius: 50%;
}

.personal_class_btn {
    width: 206px;
    height: 40px;
    line-height: 40px;
    background: #210F0380;
    border: 1px solid #FFFFFF4D;
    margin: 0 auto;
    border-radius: 22.5px;
    color: #fff;
    text-align: center;
    font-size: 14px;
}

.group_class_btn {
    padding: 6px;
    line-height: 24px;
    color: #fff;
    font-size: 14px;
    background: #210F03CC;
    border: 1px solid #FFFFFF99;
    border-radius: 12px;
    text-align: center;
    width: calc(100% - 24px);
    margin: 0 auto;
}

.groupe_class_btn_end {
    padding: 13px;
    line-height: 24px;
    color: #d9d9d9;
    font-size: 14px;
    background: #210F0333;
    border-radius: 12px;
    text-align: center;
    width: calc(100% - 24px);
    margin: 0 auto;
}

.personal_class_btn_wrap {
    display: flex;
    gap: 12px;
    padding: 0 12px;
}

.small {
    background: #210F034D;
    flex-basis: 38%;
    margin: 0;
}

.personal_schedule_btn {
    position: relative;
    background: #210F03B2;
    line-height: 24px;
    color: #fff;
    border-radius: 12px;
    flex: 1;
    font-size: 14px;
    text-align: center;
    padding: 6px;
}

.tooltip {
    position: relative;
    display: inline-block;
    background: #f7f7f7;
    border-radius: 10px;
    padding: 10px 20px;
    box-shadow: 0px 0px 50px 0px #210F031F;
    font-size: 16px;
    color: #333;
}

.tooltip::after {
    content: '';
    position: absolute;
    top: -40px;
    /* Adjust this value to move the pointer up/down */
    left: 50%;
    transform: translateX(-50%);
    border-width: 24px;
    border-style: solid;
    border-color: transparent transparent #f7f7f7 transparent;
    border: 1px solid #fff;
}

.close-btn {
    position: absolute;
    top: 50%;
    right: -15px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
}

.close-btn::before {
    content: '×';
    font-size: 14px;
    line-height: 1;
}

.cont_wrap_box {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #ededed;
    padding-right: 16px;
}

.title {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    color: #210f03;
}

.sub_title {
    font-size: 10px;
    font-weight: 500;
    line-height: 20px;
    color: #606060;
}

.sub_title2 {
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
}
</style>
